module.exports = "/fast-coin/img/coin/anim/out_1/out_1_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_000.png
// module id = 2296
// module chunks = 5